/**
 * JS-level color maps for visualization components that can't use CSS variables
 * (Cytoscape, ReactFlow, etc.)
 *
 * BSC / confidence colors are semantic and theme-invariant — NOT included here.
 */

interface GraphColors {
  nodeBg: string
  nodeBorder: string
  nodeText: string
  edgeColor: string
  selectedBorder: string
  hoverBg: string
  labelBg: string
  labelText: string
  canvasBg: string
}

interface ReactFlowColors {
  background: string
  border: string
  nodeText: string
  edgeLabelBg: string
  handleBorder: string
  minimapBg: string
}

interface ThemeColorSet {
  graph: GraphColors
  reactFlow: ReactFlowColors
}

export const themeColors: Record<'dark' | 'light', ThemeColorSet> = {
  dark: {
    graph: {
      nodeBg: '#2d2d30',
      nodeBorder: '#555',
      nodeText: '#000000',
      edgeColor: '#666',
      selectedBorder: '#007acc',
      hoverBg: '#3e3e42',
      labelBg: '#1e1e1e',
      labelText: '#cccccc',
      canvasBg: '#1a1a1a',
    },
    reactFlow: {
      background: '#1a1a1a',
      border: '#333',
      nodeText: '#ffffff',
      edgeLabelBg: '#242424',
      handleBorder: '#242424',
      minimapBg: '#1e1e1e',
    },
  },
  light: {
    graph: {
      nodeBg: '#ffffff',
      nodeBorder: '#000000',
      nodeText: '#000000',
      edgeColor: '#000000',
      selectedBorder: '#005fb8',
      hoverBg: '#dce1e8',
      labelBg: '#edf0f4',
      labelText: '#000000',
      canvasBg: '#f0f2f5',
    },
    reactFlow: {
      background: '#f0f2f5',
      border: '#c0c5cc',
      nodeText: '#1f1f1f',
      edgeLabelBg: '#ffffff',
      handleBorder: '#ffffff',
      minimapBg: '#edf0f4',
    },
  },
}
